import { LEAGUE_TABLE_COLUMNS_STATIC } from "../../constants/Constants";


function download_csv(csv, filename) {
    // CSV FILE
    let csvFile = new Blob([csv], { type: "text/csv" });
    // Download link
    let downloadLink = document.createElement("a");
    // File name
    downloadLink.download = filename;
    // We have to create a link to the file
    downloadLink.href = window.URL.createObjectURL(csvFile);
    // Make sure that the link is not displayed
    downloadLink.style.display = "none";
    // Add the link to your DOM
    document.body.appendChild(downloadLink);
    // Lanzamos
    downloadLink.click();
  }

export const export_table_to_csv = (html, filename) => {
    const csv = [];
    const rows = html.querySelectorAll("table tr");
    for (let i = 0; i < rows.length; i++) {
      let row = [], cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++)
        row.push(cols[j].innerText);
      csv.push(row.join(","));
    }
    // Download CSV
    download_csv(csv.join("\n"), filename);
  }